import { _adapters as chartJSAdapter } from "chart.js";
import moment from "moment";

const FORMATS = {
  datetime: "MMM D, YYYY, h:mm:ss a",
  millisecond: "h:mm:ss.SSS a",
  second: "h:mm:ss a",
  minute: "h:mm a",
  hour: "hA",
  day: "MMM D",
  week: "ll",
  month: "MMM YYYY",
  quarter: "[Q]Q - YYYY",
  year: "YYYY",
};

const { _date } = chartJSAdapter;
_date.override({
  formats: () => FORMATS,
  parse: (value: any, format) => {
    let time: moment.Moment = value;
    if (typeof value === "string" && typeof format === "string") {
      time = moment.utc(value, format);
    } else if (!moment.isMoment(value)) {
      time = moment.utc(value);
    }
    return time.isValid() ? time.valueOf() : null;
  },
  format: (value, format) => moment.utc(value).format(format),
  add: (value, amount, unit) => moment.utc(value).add(amount, unit).valueOf(),
  diff: (maxValue, minValue, unit) => moment.utc(maxValue).diff(moment(minValue), unit),
  startOf: (value, unit, weekday) => {
    const time = moment.utc(value);
    if (unit === "isoWeek") {
      const isoWeekday = Math.trunc(Math.min(Math.max(0, weekday ?? 0), 6));
      return time.isoWeekday(isoWeekday).startOf("day").valueOf();
    }
    return time.startOf(unit).valueOf();
  },
  endOf: (time, unit) => moment.utc(time).endOf(unit).valueOf(),
});
